export enum RegionsEnum {
  NAR = "NAR",
  EMERGENTWORKS = "EMERGENTWORKS",
  NYCHDC = "NYCHDC",
  BIRMINGHAM_AL = "BIRMINGHAM_AL",
  MOBILE_AL = "MOBILE_AL",
  MONTGOMERY_AL = "MONTGOMERY_AL",
  LITTLEROCK_AR = "LITTLEROCK_AR",
  PHOENIX_AZ = "PHOENIX_AZ",
  FRESNO_CA = "FRESNO_CA",
  LOSANGELES_CA = "LOSANGELES_CA",
  OAKLAND_CA = "OAKLAND_CA",
  SACRAMENTO_CA = "SACRAMENTO_CA",
  SANDIEGO_CA = "SANDIEGO_CA",
  SANFRANCISCO_CA = "SANFRANCISCO_CA",
  SANJOSE_CA = "SANJOSE_CA",
  STOCKTON_CA = "STOCKTON_CA",
  DENVER_CO = "DENVER_CO",
  PUEBLO_CO = "PUEBLO_CO",
  BRIDGEPORTANDFAIRFIELD_CT = "BRIDGEPORTANDFAIRFIELD_CT",
  HARTFORD_CT = "HARTFORD_CT",
  NEWBRITAIN_CT = "NEWBRITAIN_CT",
  NEWHAVEN_CT = "NEWHAVEN_CT",
  STAMFORDDARIENANDNEWCANAAN_CT = "STAMFORDDARIENANDNEWCANAAN_CT",
  WATERBURY_CT = "WATERBURY_CT",
  JACKSONVILLE_FL = "JACKSONVILLE_FL",
  MIAMI_FL = "MIAMI_FL",
  STPETERSBURG_FL = "STPETERSBURG_FL",
  TAMPA_FL = "TAMPA_FL",
  ATLANTA_GA = "ATLANTA_GA",
  AUGUSTA_GA = "AUGUSTA_GA",
  COLUMBUS_GA = "COLUMBUS_GA",
  MACON_GA = "MACON_GA",
  SAVANNAH_GA = "SAVANNAH_GA",
  CEDARRAPIDS_IA = "CEDARRAPIDS_IA",
  DAVENPORT_IA = "DAVENPORT_IA",
  DESMOINES_IA = "DESMOINES_IA",
  DUBUQUE_IA = "DUBUQUE_IA",
  SIOUXCITY_IA = "SIOUXCITY_IA",
  WATERLOO_IA = "WATERLOO_IA",
  AURORA_IL = "AURORA_IL",
  CHICAGO_IL = "CHICAGO_IL",
  DECATUR_IL = "DECATUR_IL",
  EASTSTLOUIS_IL = "EASTSTLOUIS_IL",
  JOLIET_IL = "JOLIET_IL",
  ROCKFORD_IL = "ROCKFORD_IL",
  SPRINGFIELD_IL = "SPRINGFIELD_IL",
  EVANSVILLE_IN = "EVANSVILLE_IN",
  FORTWAYNE_IN = "FORTWAYNE_IN",
  INDIANAPOLIS_IN = "INDIANAPOLIS_IN",
  LAKECOGARY_IN = "LAKECOGARY_IN",
  MUNCIE_IN = "MUNCIE_IN",
  SOUTHBEND_IN = "SOUTHBEND_IN",
  TERREHAUTE_IN = "TERREHAUTE_IN",
  TOPEKA_KS = "TOPEKA_KS",
  WICHITA_KS = "WICHITA_KS",
  NEWORLEANS_LA = "NEWORLEANS_LA",
  SHREVEPORT_LA = "SHREVEPORT_LA",
  ARLINGTON_MA = "ARLINGTON_MA",
  BELMONT_MA = "BELMONT_MA",
  BOSTON_MA = "BOSTON_MA",
  BRAINTREE_MA = "BRAINTREE_MA",
  BROCKTON_MA = "BROCKTON_MA",
  BROOKLINE_MA = "BROOKLINE_MA",
  CAMBRIDGE_MA = "CAMBRIDGE_MA",
  CHELSEA_MA = "CHELSEA_MA",
  EVERETT_MA = "EVERETT_MA",
  FITCHBURG_MA = "FITCHBURG_MA",
  HAVERHILL_MA = "HAVERHILL_MA",
  HOLYOKECHICOPEE_MA = "HOLYOKECHICOPEE_MA",
  LAWRENCE_MA = "LAWRENCE_MA",
  LEXINGTON_MA = "LEXINGTON_MA",
  LOWELL_MA = "LOWELL_MA",
  LYNN_MA = "LYNN_MA",
  MALDEN_MA = "MALDEN_MA",
  MILTON_MA = "MILTON_MA",
  PITTSFIELD_MA = "PITTSFIELD_MA",
  QUINCY_MA = "QUINCY_MA",
  SALEM_MA = "SALEM_MA",
  WORCESTER_MA = "WORCESTER_MA",
  BALTIMORE_MD = "BALTIMORE_MD",
  BATTLECREEK_MI = "BATTLECREEK_MI",
  BAYCITY_MI = "BAYCITY_MI",
  DETROIT_MI = "DETROIT_MI",
  FLINT_MI = "FLINT_MI",
  GRANDRAPIDS_MI = "GRANDRAPIDS_MI",
  KALAMAZOO_MI = "KALAMAZOO_MI",
  MUSKEGON_MI = "MUSKEGON_MI",
  PONTIAC_MI = "PONTIAC_MI",
  SAGINAW_MI = "SAGINAW_MI",
  DULUTH_MN = "DULUTH_MN",
  MINNEAPOLIS_MN = "MINNEAPOLIS_MN",
  STPAUL_MN = "STPAUL_MN",
  GREATERKANSASCITY_MO = "GREATERKANSASCITY_MO",
  SPRINGFIELD_MO = "SPRINGFIELD_MO",
  STJOSEPH_MO = "STJOSEPH_MO",
  ASHEVILLE_NC = "ASHEVILLE_NC",
  CHARLOTTE_NC = "CHARLOTTE_NC",
  DURHAM_NC = "DURHAM_NC",
  GREENSBORO_NC = "GREENSBORO_NC",
  WINSTONSALEM_NC = "WINSTONSALEM_NC",
  MANCHESTER_NH = "MANCHESTER_NH",
  ATLANTICCITY_NJ = "ATLANTICCITY_NJ",
  BERGENCO_NJ = "BERGENCO_NJ",
  CAMDEN_NJ = "CAMDEN_NJ",
  ESSEXCO_NJ = "ESSEXCO_NJ",
  HUDSONCO_NJ = "HUDSONCO_NJ",
  PASSAICCOUNTY_NJ = "PASSAICCOUNTY_NJ",
  PERTHAMBOY_NJ = "PERTHAMBOY_NJ",
  TRENTON_NJ = "TRENTON_NJ",
  UNIONCO_NJ = "UNIONCO_NJ",
  ALBANY_NY = "ALBANY_NY",
  BINGHAMTONJOHNSONCITY_NY = "BINGHAMTONJOHNSONCITY_NY",
  BRONX_NY = "BRONX_NY",
  BROOKLYN_NY = "BROOKLYN_NY",
  BUFFALO_NY = "BUFFALO_NY",
  ELMIRA_NY = "ELMIRA_NY",
  JAMESTOWN_NY = "JAMESTOWN_NY",
  LOWERWESTCHESTERCO_NY = "LOWERWESTCHESTERCO_NY",
  MANHATTAN_NY = "MANHATTAN_NY",
  NIAGARAFALLS_NY = "NIAGARAFALLS_NY",
  POUGHKEEPSIE_NY = "POUGHKEEPSIE_NY",
  QUEENS_NY = "QUEENS_NY",
  ROCHESTER_NY = "ROCHESTER_NY",
  SCHENECTADY_NY = "SCHENECTADY_NY",
  STATENISLAND_NY = "STATENISLAND_NY",
  SYRACUSE_NY = "SYRACUSE_NY",
  TROY_NY = "TROY_NY",
  UTICA_NY = "UTICA_NY",
  AKRON_OH = "AKRON_OH",
  CANTON_OH = "CANTON_OH",
  CLEVELAND_OH = "CLEVELAND_OH",
  DAYTON_OH = "DAYTON_OH",
  HAMILTON_OH = "HAMILTON_OH",
  LIMA_OH = "LIMA_OH",
  LORAIN_OH = "LORAIN_OH",
  PORTSMOUTH_OH = "PORTSMOUTH_OH",
  SPRINGFIELD_OH = "SPRINGFIELD_OH",
  TOLEDO_OH = "TOLEDO_OH",
  WARREN_OH = "WARREN_OH",
  YOUNGSTOWN_OH = "YOUNGSTOWN_OH",
  PORTLAND_OR = "PORTLAND_OR",
  ALTOONA_PA = "ALTOONA_PA",
  ERIE_PA = "ERIE_PA",
  JOHNSTOWN_PA = "JOHNSTOWN_PA",
  MCKEESPORT_PA = "MCKEESPORT_PA",
  NEWCASTLE_PA = "NEWCASTLE_PA",
  PHILADELPHIA_PA = "PHILADELPHIA_PA",
  PITTSBURGH_PA = "PITTSBURGH_PA",
  YORK_PA = "YORK_PA",
  WOONSOCKET_RI = "WOONSOCKET_RI",
  COLUMBIA_SC = "COLUMBIA_SC",
  CHATTANOOGA_TN = "CHATTANOOGA_TN",
  KNOXVILLE_TN = "KNOXVILLE_TN",
  DALLAS_TX = "DALLAS_TX",
  ELPASO_TX = "ELPASO_TX",
  HOUSTON_TX = "HOUSTON_TX",
  OGDEN_UT = "OGDEN_UT",
  SALTLAKECITY_UT = "SALTLAKECITY_UT",
  LYNCHBURG_VA = "LYNCHBURG_VA",
  NORFOLK_VA = "NORFOLK_VA",
  RICHMOND_VA = "RICHMOND_VA",
  ROANOKE_VA = "ROANOKE_VA",
  SEATTLE_WA = "SEATTLE_WA",
  SPOKANE_WA = "SPOKANE_WA",
  TACOMA_WA = "TACOMA_WA",
  KENOSHA_WI = "KENOSHA_WI",
  MILWAUKEE_WI = "MILWAUKEE_WI",
  OSHKOSH_WI = "OSHKOSH_WI",
  RACINE_WI = "RACINE_WI",
  CHARLESTON_WV = "CHARLESTON_WV",
  HUNTINGTON_WV = "HUNTINGTON_WV",
  WHEELING_WV = "WHEELING_WV",
}
